import api from "../../../api/axios";

const PAYMENT_BASE = "/payment";

export const fetchPlans = ({ signal } = {}) =>
  api.get(`${PAYMENT_BASE}/plans/`, { signal }).then((res) => res.data);

export const fetchPlan = (planId, { signal } = {}) =>
  api.get(`${PAYMENT_BASE}/plans/${planId}/`, { signal }).then((res) => res.data);

export const fetchMySubscription = ({ signal } = {}) =>
  api.get(`${PAYMENT_BASE}/me/`, { signal }).then((res) => res.data);

export const fetchMyPayments = ({ signal } = {}) =>
  api.get(`${PAYMENT_BASE}/me/payments/`, { signal }).then((res) => res.data);

export const initiateCheckout = (planId, { signal } = {}) =>
  api
    .post(`${PAYMENT_BASE}/checkout/`, { plan_id: planId }, { signal })
    .then((res) => res.data);

export const cancelSubscription = ({ signal } = {}) =>
  api.post(`${PAYMENT_BASE}/cancel/`, {}, { signal }).then((res) => res.data);
